'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'floppy-disk';
var width = 448;
var height = 512;
var aliases = [128190,128426,"save"];
var unicode = 'f0c7';
var svgPathData = ['M0 32L0 64 0 448l0 32 32 0 384 0 32 0 0-32 0-288 0-13.3-9.4-9.4-96-96L333.3 32 320 32 32 32 0 32zM64 96l256 0 0 128L64 224 64 96zM288 352a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z', 'M224 288a64 64 0 1 0 0 128 64 64 0 1 0 0-128z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFloppyDisk = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;